import { AEMBenefits } from './benefits.interfaces';
import { AEMFastActionBanner } from './fast-action-banner.interfaces';
import { Tracker } from './overview.interface';
import { AEMQuickLinks } from './quick-links.interfaces';
import { AEMRelatedLinks } from './related-links.interfaces';
import { SkyClub } from './skyclub-tracker.interfaces';
import { AEMSnapshot } from './snapshot.interfaces';
import { AEMSummary } from './summary.interfaces';
import { AEMUpgrades } from './upgrades.interfaces';

export interface AEMRequestProperty {
  carrierCode: string;
  preferenceCategoryCode: string;
}

export interface AEMCampaignId {
  banner: string;
  format: string;
  micromoments: string;
  offers: string;
}

export interface AEMStipulation {
  title: string;
  description: string;
}

export interface AEMEarns {
  fastActionBanner: AEMFastActionBanner;
  title: string;
}

export interface AEMOverview {
  onboarding: string;
  summary: AEMSummary;
  tracker: Tracker;
}

export interface AEMContent {
  overview: AEMOverview;
  quickLinks: AEMQuickLinks;
  skyClub: SkyClub;
  benefits: AEMBenefits;
  snapshot: AEMSnapshot;
  upgrades: AEMUpgrades;
  earns: AEMEarns;
  relatedLink: AEMRelatedLinks;
  stipulation: AEMStipulation;
  campaignId: AEMCampaignId;
  requestProperty: AEMRequestProperty;
}
